import { IExportPlugin, PluginType } from '@/version-types';
import { EliminatePenController, EliminatePenPlugin } from './controller';
import eliminatePenPluginState from './states/eliminate-pen-state';
import { EliminatePenPluginView } from './views';

const exportPlugin: IExportPlugin = {
    type: PluginType.STAGE,
    sort: 10,
    name: 'stage-eliminate-pen',
    render() {
        return <EliminatePenPluginView />;
    },
    createInstance({ identity }) {
        return [
            { key: 'EliminatePenController', value: new EliminatePenController(identity) },
            { key: 'EliminatePenPlugin', value: new EliminatePenPlugin(identity) },
        ];
    },
    createState() {
        return [eliminatePenPluginState];
    },
};

export default exportPlugin;
